import type { Locale } from '@/lib/i18n';

/**
 * Format a price with a currency ticker suffix.
 * Crypto currencies (BTC/LTC) need up to 8 decimals; USDT uses 2.
 * Falls back to the raw value + ticker if the amount is not finite.
 */
export function formatPrice(
  price: string | number,
  currency: string,
  locale: Locale,
): string {
  const amount = typeof price === 'string' ? Number(price) : price;
  const ticker = (currency || 'USDT').toUpperCase();
  if (!Number.isFinite(amount)) return `${price} ${ticker}`;
  const maxFrac = ticker === 'USDT' ? 2 : 8;
  const formatted = new Intl.NumberFormat(locale, {
    maximumFractionDigits: maxFrac,
    minimumFractionDigits: 0,
  }).format(amount);
  return `${formatted} ${ticker}`;
}
